import React from "react";
import { useAppData } from "../../../common/hooks/useAppData";
import {
  useTranslate,
  FormTab,
  TextInput,
  SelectInput,
  required,
  FormDataConsumer,
  TabbedForm,
} from "react-admin";
import { DocumentUploader } from "../../common/form/DocumentUploader";
import { InnerTrailerForm } from "./InnerTrailerForm";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

export const TrailerForm = (props: any) => {
  const translate = useTranslate();
  const numYears = new Date().getFullYear() - 2000;
  const years = [...Array(numYears + 1)].map((_, i) => ({
    id: 2000 + i,
    name: (2000 + i).toString(),
  }));
  const companies = useAppData((x) => x.companies) ?? [];
  const trailerTypeValues = useAppData((x) => x.trailerTypes) ?? [];
  const trailerTypes = trailerTypeValues.map((x) => ({
    id: x,
    name: translate(`appData.trailerTypes.${x}`),
  }));
  const suspensionValues = useAppData((x) => x.trailerSuspensionTypes) ?? [];
  const suspensions = suspensionValues.map((x) => ({
    id: x,
    name: translate(`appData.trailerSuspensionTypes.${x}`),
  }));
  const ownershipValues = useAppData((x) => x.trailerOwnershipTypes) ?? [];
  const ownerships = ownershipValues.map((x) => ({
    id: x,
    name: translate(`appData.ownershipTypes.${x}`),
  }));
  const documentTypes =
    useAppData(
      (x) => x.knownDocumentTypes && x.knownDocumentTypes["Trailer"]
    ) ?? [];

  const defaultCompany = companies.length === 1 ? companies[0] : undefined;

  return (
    <TabbedForm className="form-create-edit" variant="outlined" {...props}>
      <FormTab label="resources.admin-trailers.labels.general">
        <ProtectedElement
          source="trailerType"
          label="resources.admin-trailers.labels.type"
        >
          <SelectInput choices={trailerTypes} />
        </ProtectedElement>

        <FormDataConsumer>
          {({ formData, scopedFormData, getSource, ...rest }) =>
            formData["trailerType"] !== "Po" && (
              <InnerTrailerForm
                years={years}
                suspensions={suspensions}
                {...rest}
              />
            )
          }
        </FormDataConsumer>
      </FormTab>
      <FormTab label="resources.admin-trailers.labels.companyInfo">
        <ProtectedElement
          source="companyId"
          label="resources.admin-trailers.labels.company"
          validate={required()}
        >
          <SelectInput choices={companies} defaultValue={defaultCompany?.id} />
        </ProtectedElement>
        <ProtectedElement
          source="name"
          label="resources.admin-trailers.labels.name"
          validate={required()}
        >
          <TextInput source="name" />
        </ProtectedElement>
        <FormDataConsumer>
          {({ formData, scopedFormData, getSource, ...rest }) =>
            formData["trailerType"] !== "Po" && (
              <ProtectedElement
                source="ownership"
                label="resources.admin-trailers.labels.ownership"
                {...rest}
              >
                <SelectInput choices={ownerships} />
              </ProtectedElement>
            )
          }
        </FormDataConsumer>
      </FormTab>
      <FormTab label="resources.common.labels.documents">
        <ProtectedElement source="documents">
          <DocumentUploader source="documents" documentTypes={documentTypes} />
        </ProtectedElement>
      </FormTab>
    </TabbedForm>
  );
};
